import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAverageFulfillmentPerHour = {
  name: "getAverageFulfillmentPerHour" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
